import { render, staticRenderFns } from "./ScholarshipWrapper.vue?vue&type=template&id=186c8250"
import script from "./ScholarshipWrapper.vue?vue&type=script&lang=js"
export * from "./ScholarshipWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186c8250')) {
      api.createRecord('186c8250', component.options)
    } else {
      api.reload('186c8250', component.options)
    }
    module.hot.accept("./ScholarshipWrapper.vue?vue&type=template&id=186c8250", function () {
      api.rerender('186c8250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/ScholarshipWrapper.vue"
export default component.exports